"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKOptions = void 0;
const base_58_1 = __importDefault(require("base-58"));
const js_sha256_1 = require("js-sha256");
class SDKOptions {
    constructor(browser) {
        this.browser = browser;
        this.rules = {
            appKey: ['required', 'string'],
            apiURL: ['string', 'url'],
            build: ['string'],
            baseURL: ['string', 'url'],
            debug: ['boolean'],
            deviceName: ['string'],
            overrideConsoleMethods: ['boolean'],
            printToConsole: ['boolean'],
            logBrowserEvents: ['boolean'],
            logUIEvents: ['boolean'],
            registerErrorHandler: ['boolean'],
            version: ['string'],
        };
    }
    init(options) {
        options = Object.assign({}, options);
        this.validate(options);
        Object.entries(options).forEach(([key, value]) => {
            if (typeof value === 'undefined') {
                delete options[key];
            }
        });
        ['build', 'version'].forEach(opt => {
            var _a;
            if (((_a = options[opt]) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
                delete options[opt];
            }
        });
        return Object.assign({ appID: base_58_1.default.encode(js_sha256_1.sha256.array(options.appKey)).substring(0, 10), apiURL: 'https://api.bugfender.com', baseURL: 'https://dashboard.bugfender.com', debug: false, deviceName: this.browser.getDeviceName(), overrideConsoleMethods: true, printToConsole: true, logBrowserEvents: true, logUIEvents: true, registerErrorHandler: true, version: '0.0.0', build: '0' }, options);
    }
    validate(options) {
        const urlValidator = new RegExp(/^http(s)?:\/\//i);
        Object.entries(this.rules).forEach(([key, rules]) => {
            const value = options[key];
            rules.forEach(rule => {
                if (rule === 'required') {
                    if (typeof value === 'undefined') {
                        throw new Error(`Bugfender requires '${key}' option to initialize.`);
                    }
                }
                else if (rule === 'string') {
                    if (!['string', 'undefined'].includes(typeof value)) {
                        throw new Error(`'${key}' option must be a string.`);
                    }
                }
                else if (rule === 'url') {
                    if (typeof value !== 'undefined' && !urlValidator.test(value)) {
                        throw new Error(`'${key}' option must be a valid URL.`);
                    }
                }
                else if (rule === 'boolean') {
                    if (!['boolean', 'undefined'].includes(typeof value)) {
                        throw new Error(`'${key}' option must be a boolean.`);
                    }
                }
            });
        });
    }
}
exports.SDKOptions = SDKOptions;
